export default __webpack_public_path__ + "static/media/fireball.a76aadd3.svg";